import React, { Component } from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { func, object } from 'prop-types';
import Select from 'react-select';
import { Label, FormGroup } from 'reactstrap';
import CustomControl from '../CustomControl/CustomControl';
import { selectorValues } from './iframeConstructorConfig';

class IframeConstructorControlsAdditional extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    handleAdditionalSettingsChange: func.isRequired,
    handleSelectorChange: func.isRequired,
    settings: object.isRequired,
  };

  render() {
    const { handleSelectorChange, handleAdditionalSettingsChange, intl, settings } = this.props;
    return (
      <div className="iframe-constructor-controls-block">
        <h3 className="iframe-constructor-controls-block-title">
          <FormattedMessage
            id="iframe_constructor.сontrols.additional.title"
            defaultMessage="Additional settings"
          />
        </h3>

        <FormGroup>
          <Label for="iframe-constructor-additional-selector">
            <FormattedMessage
              id="iframe_constructor.сontrols.additional.selector.title"
              defaultMessage="Country selector"
            />
          </Label>
          <Select
            id="iframe-constructor-additional-selector"
            name="countrySelector"
            value={settings.additional.countrySelector}
            onChange={handleSelectorChange}
            options={selectorValues.map(option => ({
              value: option.value,
              label: intl.formatMessage({
                id: option.label.id,
                defaultMessage: option.label.defaultMessage,
              }),
            }))}
            clearable={false}
            searchable={false}
            className="Select--sm"
          />
        </FormGroup>

        <FormGroup>
          <CustomControl
            id="ic__form-show-examples-status"
            name="showExamples"
            type="checkbox"
            className="custom-control-xs"
            value={'showExamples'}
            onChange={handleAdditionalSettingsChange}
            checked={settings.additional.showExamples}
          >
            <FormattedMessage
              id="iframe_constructor.сontrols.additional.examples.title"
              defaultMessage="Show field fill examples"
            />
          </CustomControl>
        </FormGroup>

        <FormGroup>
          <CustomControl
            id="ic__form-show-privacy-status"
            name="showPrivacyAgreement"
            type="checkbox"
            className="custom-control-xs"
            value={'showPrivacyAgreement'}
            onChange={handleAdditionalSettingsChange}
            checked={settings.additional.showPrivacyAgreement}
          >
            <FormattedMessage
              id="iframe_constructor.сontrols.additional.privacy.title"
              defaultMessage="Show notification of consent to the processing of personal data"
            />
          </CustomControl>
        </FormGroup>
      </div>
    );
  }
}

export default injectIntl(IframeConstructorControlsAdditional);
